<template>
  <div class="d-flex flex-column bg-light" id="app">
    <loading v-if="$root.carregando"></loading>
    <menu-topo
      logoURL="/imgs/brasao-pbh.png"
      urlHome="/"
      :sigla="nomeSistema"
      :usuario="usuario"
      @fnLogout="logout"
    >
    </menu-topo>
    <div class="container conteudo">
      <b-breadcrumb
        v-if="showBreadcrumb && !mobile"
        :items="this.$route.meta.breadcrumb"
      ></b-breadcrumb>
      <b-alert 
          :show="mensagensAlert.length > 0 && alertDismissCountDown"
          variant="danger" 
          dismissible
          @dismissed="alertDismissed">
         <h6 class="text-dark" v-for="(mensagem,key) in mensagensAlert" :key="key">
            <b-icon-exclamation-circle variant="danger" ></b-icon-exclamation-circle> 
            {{mensagem}}
         </h6> 
      </b-alert>

      <router-view></router-view>
    </div>
    <div>
      <perguntas-frequentes></perguntas-frequentes>
    </div>
    <piweb-rodape
      logoURL="/imgs/brasao-pbh.png"
      :versao="versao"
    ></piweb-rodape>
  </div>
</template>

<script>
import MenuTopo from "@/components/MenuTopo";
import { mapGetters, mapMutations } from "vuex";
import PerguntasFrequentes from "@/components/PerguntasFrequentes";
import Loading from "@/components/LoadingComponent";
import helpers from "@/helpers";

export default {
  name: "App",
  components: { MenuTopo, PerguntasFrequentes, Loading },
  computed: {
    ...mapGetters(["isAuthenticated", "mensagensAlert"]),
  
    usuario() {
      return this.isAuthenticated
        ? { nomeCompleto: this.$store.getters.userInfo.name }
        : {};
    },

    mobile() {
      return helpers.isMobile();
    },

    showBreadcrumb() {
      return this.$route.meta?.breadcrumb?.length > 0;
    },
  },

  data() {
    return {
      nomeSistema: null,
      versao: null,
      alertDismissCountDown: 8, //8 segundos
    };
  },
  updated() {
    this.verificarVersao();
  },
  mounted() {
    this.carregarNomeSistema();
    this.setGoogleAnalytics();
  },
  methods: {
    ...mapMutations(["setMensagensAlert"]),

    carregarNomeSistema() {
      helpers.getEnv().then((response) => {
        this.nomeSistema = response.VUE_APP_NOME_SISTEMA;
      });
    },

    setGoogleAnalytics(){
      helpers.getEnv().then((response) => {
        const googleAnalyticsId = response.VUE_APP_GOOGLE_ANALYTICS_ID;

        if(googleAnalyticsId){
          const scriptGTM1 = window.document.createElement('script');
          scriptGTM1.setAttribute('async', '');
          scriptGTM1.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`);
          window.document.head.appendChild(scriptGTM1);

          const scriptGTM2 = window.document.createElement('script');
          scriptGTM2.innerText = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${googleAnalyticsId}');`
          window.document.head.appendChild(scriptGTM2);
        }
      });
    },

    logout() {
      return this.$store.dispatch("LOGOUT_REQUEST");
    },

    verificarVersao() {
      this.versao = this.$version.VUE_APP_VERSAO;
    },

    alertDismissed(){
      this.setMensagensAlert(null);
    }
  },
};
</script>

<style scoped>
.breadcrumb {
  background-color: transparent;
  padding: 0rem 0rem;
}
</style>
